import {
    Component,
    DoCheck,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from 'app/lib/api.service';
import { CalendarService } from 'app/lib/calendar.service';
import { LogService } from 'app/lib/log.service';
import { ModalService } from 'app/lib/modal.service';
import { StorageService } from 'app/lib/storage.service';
import { UserService } from 'app/lib/user.service';
import { Organization } from 'app/models/organization';
import { User } from 'app/models/user';
import * as _ from 'lodash';
import moment from 'moment';;
import { Event } from '../../../models/event';
import {
    ASSESSMENT_TYPES_CONFIG,
    TOOLS_CONFIG,
    ADMIN_CONFIG,
} from 'app//lib/constants';
import { AnalyticEvent } from 'app/lib/analytic-event';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
@Component({
    selector: 'page-user-event-assign',
    templateUrl: './user-event-assign.component.html',
    styleUrls: ['./user-event-assign.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UserEventAssignComponent implements OnInit, DoCheck {
    @Output() closeModal = new EventEmitter<boolean>();
    user: User;
    @Input() userList: User[];
    @Input() selectedUser = null;
    @Input() disableUserList: boolean = false;
    @Input() eventType: string;
    @Input() disableEventList: boolean = false;
    @Input() cssClass: string = '';
    userAddedEvents: any = [];
    selectedEventType: any;
    selectedEvent: any;
    selectedDate = moment().format();
    minDate = moment().startOf('day').format();
    isLoading: boolean = false;
    eventTypeList = [];
    eventAssignPopups: any;
    selectedEventSeriesType: any;
    showSeriesType: boolean = false;
    seriesType = [];
    showStories: boolean = false;
    showBurning: boolean = false;
    lang: any = 'en';
    orgSeriesType = [];
    public Editor = ClassicEditor;
    constructor(
        private api: ApiService,
        private logService: LogService,
        private userService: UserService,
        private calendarService: CalendarService,
        private modalService: ModalService,
        private translate: TranslateService,
        private storage: StorageService,
        private log: LogService
    ) {
        this.user = this.userService.getUser();
        this.eventTypeList = _.cloneDeep(ADMIN_CONFIG.USER_ASSIGN_TYPES_LIST);
    }

    ngOnInit(): void {
        this.translate.get('eventAssign.popups').subscribe((res: any) => {
            this.eventAssignPopups = res;
        });
        if (this.disableUserList) {
            this.selectedUser['Synched'] = 1;
            this.userList = [this.selectedUser];
        }
        if (this.eventType) {
            if (this.eventType == 'actionplan') {
                this.eventTypeList.push({
                    name: 'actionPlan.actionPlan',
                    type: 'actionplan',
                    multiSelect: false,
                    subOptions: null,
                });
            }
            this.selectedEventType = this.eventTypeList.find(
                event => event.type === this.eventType
            );
        }
        this.selectedEvent = null;
        this.userAddedEvents = [];
        this.setOrgDetails();
        this.lang = this.translate.currentLang;
    }

    setOrgDetails() {
        if (this.storage.get('orgselect')) {
            let orgID = this.storage.get('orgselect');
            this.getOrgDetails(orgID);
        } else {
            this.getOrgDetails(this.user.primaryOrganization.id);
        }
    }

    getOrgDetails(orgID: any) {
        this.api.get('organizations/' + orgID).subscribe(
            (result: any) => {
                let organization = new Organization(result.data, 'full');
                this.generateAssessmentList(organization.assessmentConfig);
                this.generateToolsList(organization.toolsConfig);
                this.generateCourseList(organization, organization);
                this.getOrgContent();
            },
            (error: any) => {
                this.log.error('Error getting organizations. ' + error.message);
            },
            () => {}
        );
    }

    generateAssessmentList(assessmentListData: any) {
        let assessmentList = this.eventTypeList.find(
            event => event.type === 'assessment'
        );
        let listData = [];
        assessmentListData.forEach((assessment: any) => {
            listData.push({
                name:
                    ASSESSMENT_TYPES_CONFIG.ASSESSMENT_LIST_LANG[assessment.key]
                        ?.title || assessment.Comment,
                subOptions: null,
                type: ADMIN_CONFIG.USER_ASSIGN_ASSESSMENT_TYPES[assessment.key],
                enabled: assessment.enabled,
            });
        });
        assessmentList.subOptions = [...listData];
    }

    ngDoCheck() {
        this.lang = this.translate.currentLang;
    }

    generateToolsList(toolsListData: any) {
        let toolsList = this.eventTypeList.find(
            event => event.type === 'tools'
        );
        let listData = [];
        toolsListData.forEach((tool: any) => {
            listData.push({
                name:
                    TOOLS_CONFIG.TOOLS_LIST_LANG[tool.key]?.title ||
                    tool.Comment,
                subOptions: null,
                type: tool.key,
                enabled: tool.enabled,
            });
        });
        toolsList.subOptions = [...listData];
    }

    generateCourseList(seriesData: any, organization: any) {
        if (this.selectedEventType?.type === 'series') {
            this.showSeriesType = true;
        }
        const enableSeriesType = [
            { id: '1', name: 'Videos', key: 'video', multiSelect: true },
            { id: '2', name: 'Stories', key: 'story' },
            { id: '3', name: 'Burning Questions', key: 'burningQuestion' },
        ];
        this.seriesType = [
            enableSeriesType.find(item => item.key === 'video'),
            organization.enableStory
                ? enableSeriesType.find(item => item.key === 'story')
                : null,
            organization.enableBurningQuestion
                ? enableSeriesType.find(item => item.key === 'burningQuestion')
                : null,
        ].filter(Boolean);
        const courseList = this.eventTypeList.find(
            event => event.type === 'series'
        );
        courseList.subType = this.seriesType.map(type => ({
            ...type,
            subOptions: [],
        }));
        const subTypeMap: { [key: string]: any } = {};
        courseList.subType.forEach(type => {
            subTypeMap[type.key] = type;
        });
        const pushToSubType = (key: string, item: any) => {
            subTypeMap[key]?.subOptions?.push(item);
        };
        seriesData.courses?.forEach((course: any) => {
            pushToSubType('video', {
                name: course.name,
                type: course.key,
                subOptions: null,
                enabled: course.enabled,
                key: 'video',
                id: course.id,
            });
        });
        seriesData.storiesConfig?.forEach((story: any) => {
            if (story.enabled && story.active) {
                pushToSubType('story', {
                    ...story,
                    name: story['title_' + this.lang],
                    id: story.seriesId,
                    subOptions: null,
                    type: 'story',
                });
            }
        });
        seriesData.burningQuestionsConfig?.forEach((bq: any) => {
            if (bq.enabled && bq.active) {
                pushToSubType('burningQuestion', {
                    ...bq,
                    name: bq['title_' + this.lang],
                    id: bq.seriesId,
                    subOptions: null,
                    type: 'burningquestion',
                });
            }
        });
    }

    cancel() {
        this.closeModal.emit(false);
    }

    onChangeEventType() {
        this.showSeriesType = this.selectedEventType?.type === 'series' || this.selectedEventType?.type === 'orgOwnContent' ? true : false;
        this.selectedEvent = null;
        this.selectedEventSeriesType = null;
        this.userAddedEvents = [];
    }

    onSubmit() {
        this.userAddedEvents = [];
        if (this.selectedEventType.type === 'series' || this.selectedEventType.type === 'orgOwnContent') {
            this.selectedEvent?.forEach((event: any) => {
                let newEventType = _.cloneDeep(this.selectedEventType);
                newEventType.start = this.selectedDate;
                newEventType.name = this.translate.instant(event.name);
                newEventType['itemid'] = event.id;
                newEventType.type = event.type;
                newEventType['title'] = this.translate.instant(event.name);
                newEventType['isCourse'] = true;
                let newEvent = new Event(newEventType);
                this.userAddedEvents.push(newEvent);
            });
        } else {
            let newEventType = _.cloneDeep(this.selectedEventType);
            newEventType.start = this.selectedDate;
            newEventType['isCourse'] = false;
            newEventType['title'] =
                this.selectedEventType.type === 'assessment' ||
                this.selectedEventType.type === 'tools'
                    ? this.translate.instant(this.selectedEvent.name)
                    : this.translate.instant(this.selectedEventType.name);
            newEventType.name =
                this.selectedEventType.type === 'assessment' ||
                this.selectedEventType.type === 'tools'
                    ? this.translate.instant(this.selectedEvent.name)
                    : this.translate.instant(this.selectedEventType.name);
            newEventType.type =
                this.selectedEventType.type === 'tools' ||
                this.selectedEventType.type === 'assessment'
                    ? this.selectedEvent.type
                    : this.selectedEventType.type;
            let newEvent = new Event(newEventType);
            this.userAddedEvents.push(newEvent);
        }
        this.showConfirmPopup();
    }

    showConfirmPopup() {
        let userName = this.selectedUser?.fullName || this.selectedUser?.Name;
        let eventItemsString = this.userAddedEvents
            .map(item => item.name)
            .join(' and ');
        let message = this.eventAssignPopups.confirmationMsg
            .replace('$event$', '<strong>' + eventItemsString + '</strong>')
            .replace('$userName$', '<strong>' + userName + '</strong>');
        this.modalService
            .showConfirmation(this.eventAssignPopups.confirmation, message)
            .afterClosed()
            .subscribe(result => {
                if (result) {
                    this.onSaveEvents();
                }
            });
    }

    onSaveEvents() {
        this.isLoading = true;
        let payload = {
            events: this.userAddedEvents,
            CreatorUserID: this.user.id,
            UserID: this.selectedUser.id || this.selectedUser.UserID,
        };
        this.api.post('calendar/schedule', payload).subscribe(
            (data: any) => {
                this.isLoading = false;
                this.userAddedEvents = [];
                this.modalService.showAlert(
                    this.eventAssignPopups.success,
                    this.eventAssignPopups.saveSuccessMsg
                );
                this.calendarService.triggerRefresh();
                this.closeModal.emit(true);
            },
            (error: any) => {
                this.modalService.showAlert(
                    this.eventAssignPopups.error,
                    this.eventAssignPopups.saveErrorMsg
                );
                this.logService.error('Error saving. ' + error.message);
                this.isLoading = false;
            },
            () => {}
        );
    }

    ngOnDestroy() {
        this.eventType = null;
    }
    getOrgContent() {
        if (this.selectedEventType?.type === 'orgOwnContent') {
            this.showSeriesType = true;
        }
        const enableSeriesType = [
            { id: '1', name: 'Videos', key: 'video', multiSelect: true },
            { id: '2', name: 'Stories', key: 'story' },
            { id: '3', name: 'Burning Questions', key: 'burningQuestion' },
            { id: '4', name: 'Reads', key: 'reads'},
        ];
        this.orgSeriesType = [
            enableSeriesType.find(item => item.key === 'video'),
            enableSeriesType.find(item => item.key === 'story'),
            enableSeriesType.find(item => item.key === 'burningQuestion'),
            enableSeriesType.find(item => item.key === 'reads')
        ].filter(Boolean);
        const courseList = this.eventTypeList.find(
            event => event.type === 'orgOwnContent'
        );
        courseList.subType = this.orgSeriesType.map(type => ({
            ...type,
            subOptions: [],
        }));
        const subTypeMap: { [key: string]: any } = {};
        courseList.subType.forEach(type => {
            subTypeMap[type.key] = type;
        });
        const pushToSubType = (key: string, item: any) => {
            subTypeMap[key]?.subOptions?.push(item);
        };
        let orgOwnContent = {};
        this.getOrgOwnContent().subscribe(
            (response: any) => {
                orgOwnContent = response;
                orgOwnContent['courses']?.forEach((course: any) => {
                        pushToSubType('video', {
                            name: course.Name,
                            type: course.CourseKey,
                            subOptions: null,
                            enabled: 1,
                            key: 'video',
                            id: course.ID,
                    });
                });
        orgOwnContent['stories']?.forEach((story: any) => {
            pushToSubType('story', {
                name: story.Name,
                id: story.ID,
                subOptions: null,
                type: 'story',
            });
        });
        orgOwnContent['burningquestions']?.forEach((bq: any) => {
            pushToSubType('burningQuestion', {
                name: bq.Name,
                id: bq.ID,
                subOptions: null,
                type: 'burningquestion',
            });
        });
        orgOwnContent['reads']?.forEach((read: any) => {
            pushToSubType('reads', {
                ...read,
                name: read.Name,
                id: read.ID,
                subOptions: null,
                type: 'reads',
            });
        });
            },
            (error) => {
                this.log.event(
            AnalyticEvent.internalPagesEvents.customOrgStorySeriesFetchError
            );
            }
        );
    }
    getOrgOwnContent() {
        return this.api.get(`syncheduser/allownseries/${this.selectedUser.id}`);
    }
    }